import * as C from 'actions/constants';

export const blankState = {
  meta: {},
  data: [],
  loading: false,
};

const AllCategoriesReducer = (state = blankState, action) => {
  switch (action.type) {
    case C.LOAD_ALL_CATEGORIES: {
      return { ...state, loading: true };
    }
    case C.LOAD_ALL_CATEGORIES_SUCCESS: {
      const { data, meta } = action;
      return {
        ...state, loading: false, meta, data,
      };
    }
    case C.LOAD_CATEGORIES_ERROR: {
      return { ...state, loading: false };
    }
    default:
      return state;
  }
};

export default AllCategoriesReducer;
